import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Container, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { BaseUrl } from "../../../helpers/Baseurl"


class EditBrands extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand:false,
      breadcrumbItems: [
        { title: "Brands", link: "/brands" },
        { title: "Edit Brand", link: "#" },
      ],
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
    }
	

    this.handleSubmit = this.handleSubmit.bind(this);    

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/brands')
  }
  async componentDidMount(){
      await this.loadBrand()
  }

  loadBrand(){
    const id =this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        };
        fetch(`${BaseUrl}/api/vehicles/brand/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.props.history.push(`/brands`)
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                            this.setState({brand:data})
                          }
                      )
                  }    
              }
          )

  }
  
  handleSubmit(e, values) {
    this.setState({ loading: true })
    const {brand} = this.state
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/vehicles/brand/${brand.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ loading: false })
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          toastr.success(`Brand Updated Successfully`, "") 
                          this.props.history.push(`/brands`) 
                          }
                      )
                  }    
              }
          )

  }

  render() {
      const {brand} = this.state
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Edit Brand" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Edit Brand</h4>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="name">Brand Name</Label>
                              <AvField
                                name="name"
                                placeholder="Brand Name"
                                type="text"
                                value={brand?brand.name:""}
                                errorMessage="Enter Brand Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="name"
                                
                              />
                            </div>
                          </Col> 
                        </Row>
                                          
                        <FormGroup className="mb-0">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default EditBrands;



    